import * as T from 'io-ts';
import { LuxonDateTimeT } from '../../SpecificCodecs/LuxonDateTime';
export const OrganizationTypeT = T.keyof({
    new: undefined,
    existing: undefined,
});
export const OrganizationT = T.type({
    uid: T.string,
    name: T.string,
    creator: T.string,
    createdAt: LuxonDateTimeT,
    customerId: T.string,
    subscriptionId: T.string,
    checkoutSessionId: T.string,
    subscriptionLive: T.boolean,
}, 'Organization');
